import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var SelectContainer = makeThemedComponent({
  themeKey: "Select",
  displayName: "SelectContainer",
  component: "div",
  defaultStyles: css(["border:1px solid;cursor:pointer;display:inline-block;position:relative;:after{border-left:0.5rem solid transparent;border-right:0.5rem solid transparent;border-top:0.5rem solid #000;bottom:0;content:'';height:0;margin:auto;pointer-events:none;position:absolute;right:0.25rem;top:0;width:0;right:20px;}"])
});
var OptionContainer = makeThemedComponent({
  themeKey: "OptionContainer",
  component: "select",
  defaultStyles: css(["appearance:none;background:none;border:0;cursor:pointer;font-size:inherit;outline:none;padding:0.5rem 2.5rem 0.5rem 0.5rem;width:100%;"])
});
export { SelectContainer, OptionContainer };